/**
 * API에서는 별도의 Vo로 관리하고 있지 않으나, MyNews 타입 관리의 용이성을 위해 임의로 추가해준 Enum Vo입니다.
 * 참고: https://github.kakaocorp.com/kakaopage/api/blob/0593087390ad49c5a57a7007a4ae1e1e9ad8e326/api/src/main/java/com/kakaopage/api/model/MyNewsVO.java#L11
 */
export enum MyNewsTypeVo {
  // 좌측 썸네일이 동그란 형태인 알림
  Normal = 'N',
  // 좌측 썸네일이 세로 형태인 알림
  Series = 'S',
  // 좌측 썸네일이 동그라며, 삭제가 가능한 알림
  UserRelated = 'U',
}
